module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/usuario-sistema/usuario-sistema.component.css
// module id = ./src/app/usuario-sistema/usuario-sistema.component.css
// module chunks = main